import React, { memo } from 'react';
import { convertToSlug } from '../../../utils/helpers';

const TableOfContents = memo(({ slice }) => {
  const {
    primary: { title },
    items,
  } = slice;

  return (
    <div
      className="table-of-contents p-lg-4 p-2"
      style={{ background: '#efefef', marginBottom: 30 }}
    >
      <span className="table-of-contents__title mb-2">{title}</span>
      <ul className="mb-0" style={{ marginLeft: 15 }}>
        {items?.map(({ heading, replace_heading }, index) => (
          <li key={index} className="table-of-contents__item">
            <a href={`#${convertToSlug(heading)}`}>{replace_heading || heading}</a>
          </li>
        ))}
      </ul>
    </div>
  );
});

export default TableOfContents;
